export const infinityStatuses = {
  "PENDING CONFIRMATION": {
    status: "Pending confirmation",
    description: "",
    nextStep: ["N/A"],
    icon: "",
    cssClass: "Standard"
  },
  "ORDER ERROR": {
    status: "Order placement failed",
    description: "We encountered an error while placing your order",
    nextStep: ["TBC"],
    icon: "",
    cssClass: "Standard"
  },
  "PAYMENT PENDING": {
    status: "Awaiting payment",
    description: "Your order has been placed. Once we’ve received a notification of payment, we’ll continue processing your order.",
    nextStep: ["Please make payment in order to finalise this order"],
    icon: "",
    cssClass: "Standard",
    buttons: [
      {
        label: "Make payment now",
        type: "payment"
      }
    ]
  },
  "PAYMENT FAILED": {
    status: "Payment failed",
    description: "We couldn’t process this transaction with the card details you provided",
    nextStep: ["Please try making payment again in order to finalise this order"],
    icon: "icon-cross.svg",
    cssClass: "Empty",
    buttons: [
      {
        label: "Retry payment",
        type: "payment"
      }
    ]
  },
  "PAID": {
    status: "Paid",
    description: "We’ve successfully processed this transaction",
    nextStep: [
      "Your order will be prepared and dispatched to the courier for delivery",
      "Your order should be delivered in the next 1 - 3 business days"
    ],
    icon: "",
    cssClass: "Standard"
  },
  "PROCESSING": {
    status: "Processing order",
    description: "We’ve started processing your order",
    nextStep: [
      "Once your payment has been settled, we’ll start preparing your order for dispatch",
      "Your order should be delivered in the next 1 - 3 business days"
    ],
    icon: "",
    cssClass: "Standard"
  },
  "PROCESSED": {
    status: "Preparing order",
    description: "Your payment has been settled, and we are now getting your order ready for handover to the courier",
    nextStep: ["Your order will be delivered in the next 1 - 3 business days"],
    icon: "",
    cssClass: "Standard"
  },
  "PAYMENT UNSUCCESSFUL": {
    status: "Payment unsuccessful",
    description: "Your payment could not be settled successfully",
    nextStep: ["TBC"],
    icon: "warning.svg",
    cssClass: "Empty"
  },
  "ORDER FAILED (MANUAL)": {
    status: "Order failed",
    description: "TBC",
    nextStep: ["TBC"],
    icon: "icon-cross.svg",
    cssClass: "Empty"
  },
  "BACK-ORDER": {
    status: "On backorder",
    description: "The device you’ve chosen is currently out of stock. It has been placed on backorder.",
    nextStep: [
      "As soon as we get stock of your selected device, we’ll prepare your order and dispatch it to the courier for delivery",
      "If you would like to discuss alternative options, please contact Customer Care at 082XXXX"
    ],
    icon: "",
    cssClass: "Standard"
  },
  "DISPATCHED": {
    status: "Ready for handover to courier",
    description: "Your order has been prepared and is just about to be dispatched to the courier",
    nextStep: [
      "Once your order has been dispatched, the courier will contact you to arrange a delivery date and time",
      "Your order will be delivered in the next 1 - 3 business days"
    ],
    icon: "",
    cssClass: "Standard"
  },
  "CONSIGNED": {
    status: "Handed over to courier",
    description: "Your order has been handed over to the courier for delivery",
    nextStep: [
      "The courier will contact you to arrange a delivery date and time",
      "Your order will be delivered in the next 1 - 3 business days"
    ],
    icon: "",
    cssClass: "Standard"
  },
  "DELIVERY ATTEMPT FAILED": {
    status: "Delivery attempt failed",
    description: "The courier was unable to deliver your order",
    nextStep: ["Please contact RAM at 082XXXX in order to reschedule your delivery"],
    icon: "",
    cssClass: "Standard"
  },
  "RETURNED": {
    status: "Returned",
    description: "Your order was successfully returned to us",
    nextStep: "Check out our latest products and deals. We’re sure you’ll find something that makes your heart skip a beat!",
    icon: "icon-sucess.svg",
    cssClass: "Empty"
  },
  "HIJACKED": {
    status: "Hijacked",
    description: "Unfortunately, the courier was hijacked while on their way to you. Please accept our sincerest apologies for the delay.",
    nextStep: ["The courier will contact you to reschedule your delivery for a later date"],
    icon: "",
    cssClass: "Standard"
  },
  "STOLEN": {
    status: "Stolen",
    description: "Unfortunately, your parcel was stolen from the courier while on their way to you. Please accept our sincerest apologies for the delay.",
    nextStep: ["The courier will contact you to reschedule your delivery for a later date"],
    icon: "",
    cssClass: "Standard"
  },
  "DELIVERED": {
    status: "Delivered",
    description: "Your order was delivered successfully. Enjoy!",
    nextStep: [],
    icon: "icon-sucess.svg",
    cssClass: "Empty"
  },
  /* VETTING STATUSES */
  "APPROVAL STATUS": {
    status: "Approved & submitted",
    description: "Your credit check was approved and your order successfully submitted.",
    nextStep: [
      "Your order will be prepared and handed over to the courier for delivery. Delivery normally takes 3 - 5 business days.",
      "If you’ve chosen to collect from a store, the store will let you know as soon as your order is ready for collection."
    ],
    icon: "",
    cssClass: "Standard"
  },
  "PENDED/REFERRED": {
    status: "Pending document submission",
    description: "In order to finalise your contract application, we need you to send us a few documents.",
    nextStep: [
      "Please send <a href='#details'><b>these documents</b></a> to <b><u>cadonline@vodacom.co.za</u> in PDF format</b>. Remember to quote your reference number in the subject line of your email to us.",
      "As soon as we receive your documents we will continue processing your application."
    ],
    icon: "",
    cssClass: "Standard",
    showDocs: true
  },
  "APPROVED WITH CONDITION": {
    status: "Conditionally approved",
    description: "Your credit check was approved for a different set of deals than the one you applied for",
    nextStep: [
      "Please <u>select a deal from a set of deals that you qualify for</u>",
      "Once you’ve selected and added your new deal to cart, you can continue to check out. This time we won’t have to perform a credit check again."
    ],
    icon: "",
    cssClass: "Standard",
    showCreditCheck: true,
    hideDeals: true
  },
  "DECLINE": {
    status: "Declined",
    description: "Unfortunately, your application was declined based on the credit check we performed.",
    nextStep: [
      "You’ll be able to apply for a contract again 30 days after your previous application was declined."
    ],
    icon: "",
    cssClass: "Standard"
  }
};
